import UploaderSpinner from './UploaderSpinner'

export default UploaderSpinner
